<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2">

            دسترسی چارت سازمانی
        
        </span>

    </div>

</div>


<main class="p-3" style="direction: rtl;">

    <section class="border border-2 row gx-2 gy-2 px-2">

        <div [ngClass]="list_SystemAbility.length == 0 ? 'col-12 p-1' : 'col-12 col-md-5 p-1' " >

            <div class="p-4">

                <div id="jstree" class="rtl"></div>

            </div>

        </div>

        <div [ngClass]="list_SystemAbility.length == 0 ? '' :
        
            'systemAbility_container col-12 col-md-7 p-1' " 
        
            style="max-height: 90vh;overflow: auto;">

            <div class="p-4">

                <div id="jstree_Ability" (click)="selectedAbility($event)" class="rtl"></div>

            </div>

        </div>

    </section>

</main>